module.exports = __webpack_public_path__ + "static/media/silver_keyboard.5999130a.jpg";